import { render, staticRenderFns } from "./GoUp.vue?vue&type=template&id=e461d35e&scoped=true"
import script from "./GoUp.vue?vue&type=script&lang=js"
export * from "./GoUp.vue?vue&type=script&lang=js"
import style0 from "./GoUp.vue?vue&type=style&index=0&id=e461d35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e461d35e",
  null
  
)

export default component.exports